import app from 'flarum/common/app';
import Widget from 'ext:fof/forum-widgets-core/common/components/Widget';
import extractText from 'flarum/common/utils/extractText';
export default class OnlineGuestsWidget extends Widget {
  className() {
    return 'IanM-OnlineGuestsWidget';
  }
  icon() {
    return 'fas fa-users';
  }
  title() {
    return extractText(app.translator.trans('ianm-online-guests.forum.widget.title'));
  }
  content() {
    const guestCount = app.forum.attribute('onlineGuests');
    return m("div", {
      className: "IanM-OnlineGuestsWidget-content"
    }, m("span", {
      className: "IanM-OnlineGuestsWidget-guestCount"
    }, guestCount), m("span", {
      className: "IanM-OnlineGuestsWidget-description"
    }, app.translator.trans('ianm-online-guests.forum.widget.guests_online', {
      count: guestCount
    })));
  }
}
flarum.reg.add('ianm-online-guests', 'common/components/OnlineGuestsWidget', OnlineGuestsWidget);